<p-avatar [label]="getUserInitials()" shape="circle" />
